export { default as compressImageRequest } from './compressImageRequest';



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/compressImageRequest/index.ts